module.exports = __webpack_public_path__ + "img/thumb_01.ba4cfaba.jpg";